import { Grid } from "@mui/material";
import { ReactNode } from "react";
import FormHeadChip from "@/components/FormHeadText";
import OutlineCard from "@/components/OutlineCard";

export interface FormSectionCardProps {
  title: string;
  children: ReactNode;
}

const FormSectionCard = ({ title, children }: FormSectionCardProps) => (
  <Grid item xs={12}>
    <FormHeadChip mb="10px">{title}</FormHeadChip>
    <OutlineCard>
      <Grid container spacing={2} alignItems="center" padding={1}>
        {children}
      </Grid>
    </OutlineCard>
  </Grid>
);

export default FormSectionCard;
